export default "__VITE_ASSET__zmAG4j3M__"